"use client";

import { createContext, useContext, type ReactNode } from "react";
import { useNotificationSetupBanner } from "@/lib/hooks/useNotificationSetupBanner";

export type NotificationSetupBannerContextValue = ReturnType<
  typeof useNotificationSetupBanner
>;

const NotificationSetupBannerContext = createContext<
  NotificationSetupBannerContextValue | undefined
>(undefined);

export function NotificationSetupBannerProvider({
  children,
}: {
  children: ReactNode;
}) {
  const value = useNotificationSetupBanner();
  return (
    <NotificationSetupBannerContext.Provider value={value}>
      {children}
    </NotificationSetupBannerContext.Provider>
  );
}

export function useNotificationSetupBannerContext(): NotificationSetupBannerContextValue | null {
  return useContext(NotificationSetupBannerContext) ?? null;
}

export function useNotificationSetupBannerContextRequired(): NotificationSetupBannerContextValue {
  const ctx = useContext(NotificationSetupBannerContext);
  if (!ctx) {
    throw new Error(
      "useNotificationSetupBannerContextRequired must be used within NotificationSetupBannerProvider",
    );
  }
  return ctx;
}
